import { Icon } from '@/components/icons/svg-icons';
import { useBetslipStore } from '@/store/betslip';
import { useTranslations } from 'next-intl';
import { floatQuickBetStyle } from './float-quick-bet.style';
import { useAccountInfo } from '@/hooks/query/account';
import { useBetslipContext } from '@/features/betslip/contexts/betslip-context';
import { addCommasWithFix } from '@/utils/odds-utils';
import clsx from 'clsx';
import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { BetModeControl } from '@/features/betslip/betslip-header/components/bet-mode-control';
import { useParams } from 'next/navigation';
import { usePushAside } from '@/hooks/use-push-aside';

const useIsSingleMatchPage = () => {
	const params = useParams();
	return params.matchId !== undefined;
}

export const FloatQuickBet = () => {
	const t = useTranslations('General');
	const view = useAppearanceStore(state => state.view);
	const isSingleMatchPage = useIsSingleMatchPage();
	const pushAside = usePushAside();
	const [
		isQuickBet,
		setIsQuickBetSettingModalOpen,
	] = useBetslipStore(state => [
		state.isQuickBet,
		state.setIsQuickBetSettingModalOpen
	]);
	const { user } = useAccountInfo();
	const { currencyName, currencySymbol, quickBetStake } = useBetslipContext();

	const getTitle = () => {
		return view === ViewEnum.mars ? t('lbl_OneClickBet') : t('lbl_QuickBet');
	}
	
	const openQuickBetSettingModal = () => {
		setIsQuickBetSettingModalOpen(true);

		if (view === ViewEnum.mars) {
			const kafkaData = {
				note: KafkaNote.MarsV1,
				type: 10,
				action: 3
			}

			setKafkaNormal(kafkaData);
		}
	}

	return (
		<div 
			className={clsx(
				'bet-slip__header', 
				floatQuickBetStyle.container,
				{
					[floatQuickBetStyle.breakpointTrans]: !pushAside,
					[floatQuickBetStyle.pushAside]: pushAside,
				}
			)}
			data-float={!isSingleMatchPage}
		>
			<div className={floatQuickBetStyle.content} data-active={isQuickBet}>
				<BetModeControl type={'quickBet'} />

				<div className={clsx('title', floatQuickBetStyle.title)}>
					{getTitle()}
				</div>
			
				
				{
					isQuickBet && quickBetStake > 0
						? (
							<div className={clsx('bet-slip__quick-bet-stake', floatQuickBetStyle.stake)} onClick={openQuickBetSettingModal}>

								<span>
									{`${currencyName} ${currencySymbol}${addCommasWithFix(quickBetStake)}`}
								</span>
								<Icon name={'gear-setting'} />
							</div>)
						: null
				}
				{isQuickBet && user ? (
					<div className={floatQuickBetStyle.availableFunds}>
						<div>
							{t('lbl_FAvaliableFunds')}
						</div>
						<div className="bCredit">
							{user.BCredit}
						</div>
					</div>
					
				): null}
			</div>
		</div>
	);
}